import { assets } from "@/lib/assets"
import {ArrowRight} from 'lucide-react'

function About() {
  return (
    <section id="about" data-nav="dark" className="bg-[#f3eee4] px-8 py-20 md:px-10 md:py-28">
      <div className="mx-auto max-w-5xl">
        <h2 className="font-display text-[32px] tracking-[0.2em] text-slate-700 md:text-[40px]">
          ABOUT MR.EAR
        </h2>
        <p className="mt-3 text-[13px] tracking-[0.12em] text-slate-500">
          以音樂為根，延伸更多感官的可能。
        </p>

        <div className="mt-10 overflow-hidden">
          <img
            src={assets.aboutStage}
            alt="舞台上的微光"
            className="h-[320px] w-full object-cover md:h-[420px]"
          />
        </div>

        <div className="mt-10 grid gap-10 md:grid-cols-[1.2fr_0.8fr] md:items-end">
          <div>
            <p className="font-serif-tc text-lg tracking-[0.12em] text-slate-700">
              MR.EAR 相信，
            </p>
            <p className="mt-4 max-w-xl text-[14px] leading-8 text-slate-500">
              音樂不只被聽見，也能被看見、被聞見、被記住。
              我們從演出出發，將情緒轉化為氣味，空間與日常，
              讓每一次感動，都能以不同的形式延續。
            </p>
            <a
              href="#contact"
              className="mt-8 inline-flex items-center gap-3 border border-slate-400 px-6 py-2.5 text-[12px] tracking-[0.22em] text-slate-600 transition hover:bg-[#2b4456] hover:text-white"
            >
              了解更多
              <ArrowRight size={14} />
            </a>
          </div>
          <p className="font-script text-right text-4xl text-slate-400 md:text-5xl">
            More
            <br />
            than Music.
          </p>
        </div>
      </div>
    </section>
  )
}

export default About
